export default {
  yourBudget: 'Votre budget',
  yourBudgetMinor: 'Le budget de votre enfant',
  monthlySavingCapacity:
    "Votre capacité d'épargne mensuelle est de {savingCapacityMonthly} €.",
  monthlySavingCapacityMinor:
    "La capacité d'épargne mensuelle de votre enfant est de {savingCapacityMonthly} €.",
  availableSavingsPrecautionaryConstitutes:
    'Votre épargne disponible est de {availableSavings} €. Votre épargne de précaution estimée à {precautionarySavings} € est constituée.',
  availableSavingsPrecautionaryNotConstitutes:
    "Votre épargne disponible est de {availableSavings} €. Votre épargne de précaution estimée à {precautionarySavings} € n'est pas constituée.",
  currentDebtRatio: "Votre taux d'endettement actuel est de {debtRatio} %.",
  monthlyIncome: 'Revenus mensuels',
  monthlyExpenses: 'Charges mensuelles',
  monthlyBudgetSummary: 'Synthèse de votre budget mensuel',
  monthlyBudgetSummaryMinor: 'Synthèse du budget mensuel de votre enfant',
  monthlyIncomeExpensesSimplified:
    'Revenus et Charges mensuels : répartition simplifiée',
  treasuryAndLiquidities: 'Trésorerie et Liquidités',
  availableLiquidities:
    'La sommes des liquidités disponibles est de {liquidities} €.',
  mobilizableCash:
    'La trésorerie mobilisable à court terme est de {mobilizableCash} €. La trésorerie mobilisable à court terme correspond à la trésorerie nette, c’est-à-dire le fonds de roulement diminué du besoin en fonds de roulement.',
  tableHeaders: {
    category: 'Nature / Catégorie',
    client: 'Client',
    partner: 'Conjoint',
    total: 'Total',
  },
  status: {
    afterSimulation: '(Après simulation)',
    currentSituation: '(Situation actuelle)',
  },
}
